//BONUS ENGINE

// bonus engine page
export const BONUS_ENGINE_ROOT = 'bonus-engine-root';
export const SIDE_MENU_ROOT = 'side-menu-root';

// campaign list page
export const CAMPAIGN_LIST_ROOT = 'campaign-list-root';

// campaign page
export const CAMPAIGN_ROOT = 'campaign-root';

export const GENERAL_DETAILS_ROOT = 'general-details-root';
export const PROMO_CODE_ROOT = 'promo-code-root';
export const ACTION_CONDITIONS_ROOT = 'action-conditions-root';
export const REWARD_CONDITIONS_ROOT = 'reward-conditions-root';
export const PLAYER_MANAGEMENT_ROOT = 'player-management-root';

// popups
export const DIALOG_ROOT = 'dialog-root';

// bonus creations page
export const BONUS_CREATOR_ROOT = 'bonus-creator-root';

// campaign page
export const BONUS_REWARD_ROOT = 'bonus-reward-root';
